/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProcedureTransactionHoldingSimpleViewModel } from './procedureTransactionHoldingSimpleViewModel';
import { VisitHoldingSimpleViewModel } from './visitHoldingSimpleViewModel';

export interface VisitHoldingSplitModel {
  visitHoldings?: Array<VisitHoldingSimpleViewModel> | null;
  procedures?: Array<ProcedureTransactionHoldingSimpleViewModel> | null;
}
